// extracted by mini-css-extract-plugin
export default {"item":"SideListItem_item__e3OU-","info":"SideListItem_info__kFrQw"};